var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11279_343491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8003 43.4563L43.2035 22.115L21.8622 0.711834L0.459022 22.0531L21.8003 43.4563Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11279_343491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4876 19.9599C23.1556 19.9398 22.8389 19.9957 22.553 20.112C22.2092 20.2517 21.8342 19.9939 21.8347 19.6229L21.8387 16.8655C21.8404 15.6724 20.8746 14.7038 19.6815 14.7021L16.9241 14.6981C16.5531 14.6976 16.2964 14.3217 16.4371 13.9784C16.5542 13.6929 16.6111 13.3763 16.5919 13.0442C16.5307 11.9836 15.6767 11.118 14.6169 11.0435C13.3709 10.9559 12.3319 11.9399 12.3301 13.1677C12.3297 13.4509 12.3846 13.7214 12.4846 13.9687C12.6244 14.3144 12.3701 14.6915 11.9972 14.691L9.23982 14.687C8.04668 14.6852 7.07806 15.6511 7.07634 16.8442L7.0724 19.5952C7.07182 19.9645 7.44384 20.2228 7.78673 20.0858C8.07243 19.9717 8.38855 19.9176 8.7195 19.9391C9.77594 20.0077 10.6337 20.8626 10.705 21.9189C10.7892 23.1653 9.80212 24.2017 8.57424 24.1999C8.29579 24.1995 8.02994 24.1458 7.78626 24.0484C7.44114 23.9105 7.06579 24.163 7.06525 24.5347L7.06127 27.2859C7.0595 28.4789 8.02532 29.4476 9.21846 29.4493L11.9695 29.4533C12.3387 29.4538 12.5971 29.0818 12.4601 28.7389C12.346 28.4532 12.2919 28.1372 12.3134 27.8062C12.3819 26.7497 13.2369 25.892 14.2932 25.8207C15.5396 25.7364 16.576 26.7235 16.5742 27.9514C16.5738 28.2298 16.5201 28.4957 16.4227 28.7394C16.2848 29.0845 16.5373 29.4599 16.909 29.4605L19.6601 29.4644C20.8532 29.4662 21.8219 28.5003 21.8236 27.3072L21.8276 24.5497C21.8281 24.1768 22.2059 23.9238 22.5512 24.0645C22.7983 24.1652 23.0685 24.2209 23.3518 24.2213C24.5796 24.2231 25.5666 23.1869 25.4826 21.9407C25.4112 20.8807 24.548 20.0242 23.4876 19.9599Z",
    fill: "#D9622A",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3431 29.4799L31.6607 29.4775C31.2897 29.4769 31.0319 29.852 31.1716 30.1957C31.2879 30.4816 31.3439 30.7984 31.3237 31.1304C31.2593 32.1908 30.4029 33.0539 29.3429 33.1254C28.0966 33.2094 27.0605 32.2224 27.0623 30.9945C27.0627 30.7113 27.1184 30.441 27.2191 30.194C27.3598 29.8486 27.1067 29.4709 26.7338 29.4703L23.9764 29.4663C22.7833 29.4646 21.8174 28.496 21.8192 27.3029",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8413 16.867C21.843 15.6739 22.8117 14.7081 24.0048 14.7098L26.7558 14.7138C27.1251 14.7143 27.3823 15.0871 27.2443 15.4296C27.1294 15.7149 27.0744 16.0309 27.0949 16.3619C27.1605 17.4185 28.0129 18.2787 29.069 18.3531C30.3152 18.441 31.3544 17.4569 31.3561 16.229C31.3566 15.9505 31.3036 15.6845 31.2069 15.4406C31.07 15.095 31.3237 14.7204 31.6953 14.721L34.4464 14.7249C35.6395 14.7266 36.6054 15.6952 36.6036 16.8884L36.5997 19.6458C36.5991 20.0187 36.9762 20.2729 37.3219 20.1332C37.5692 20.0332 37.8397 19.9783 38.1229 19.9787C39.3507 19.9805 40.3347 21.0194 40.2471 22.2655C40.1726 23.3252 39.307 24.1792 38.2464 24.2405C37.9144 24.2597 37.5977 24.2028 37.3122 24.0857C36.9689 23.945 36.593 24.2016 36.5925 24.5727L36.5902 26.1982",
    stroke: "#D9622A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchedIcon);
export default __webpack_public_path__ + "static/media/matched-icon.245635f746d2e5b58c212f3033d06916.svg";
export { ForwardRef as ReactComponent };